<template>
    <div>
        <template v-if="!clicked">
            <b-btn v-bind="$attrs" size="sm" @click="clicked = true">
                <slot></slot>
            </b-btn>
        </template>
        <template v-else>
            <b-btn-group>
                <b-btn
                    size="sm"
                    :variant="confirmVariant"
                    @click="$emit('confirm')"
                    ><i class="fa fa-check"></i
                ></b-btn>
                <b-btn size="sm" variant="secondary" @click="clicked = false"
                    ><i class="fa fa-times"></i
                ></b-btn>
            </b-btn-group>
        </template>
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        confirmVariant: {
            type: String,
            default: 'success',
        },
    },
    data: () => ({
        clicked: false,
    }),
}
</script>
